// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type ToolConfigListe } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useGetToolConfigsForAufgabe(): (
  aufgabeId: string,
  toolId: string
) => Promise<ToolConfigListe> {
  const getAPI = useGetApi();
  return useCallback(
    async (aufgabeId, toolId) =>
      (await getAPI()).tools.getToolConfigsForAufgabe({ aufgabeId, toolId }),
    [getAPI]
  );
}
